// extracted by mini-css-extract-plugin
export default {"container":"PatchTestRequired--container--6f088d","questionIcon":"PatchTestRequired--questionIcon--12725f"};